import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/error.tsx")